import { FC, useMemo } from 'react';
import Image from '../Image';
import { PaymentMethodsDisplayProps } from './typess';
import { PaymentMethodsType } from '@package/core/src/payment/types';
import styles from './PaymentMethodsDisplay.module.css';
import clsx from 'clsx';

const PaymentMethodsDisplay: FC<PaymentMethodsDisplayProps> = ({ paymentMethods, className, ignore = [] }) => {
  const getImageLinks = (paymentType: string): string[] => {
    if (ignore.includes(paymentType)) {
      return [];
    }

    switch (paymentType) {
      case PaymentMethodsType.CreditCard:
        return [
          '/marketplace-static/images/paymentMethods/visa.svg',
          '/marketplace-static/images/paymentMethods/mastercard.svg',
          '/marketplace-static/images/paymentMethods/amex.svg',
          '/marketplace-static/images/paymentMethods/discover.svg',
        ];
      case PaymentMethodsType.PayPal:
        return ['/marketplace-static/images/paymentMethods/paypal.svg'];
      case PaymentMethodsType.Affirm:
        return ['/marketplace-static/images/paymentMethods/affirm.svg'];
      case PaymentMethodsType.Sezzle:
        return ['/marketplace-static/images/paymentMethods/sezzle.svg'];
      case PaymentMethodsType.ApplePay:
        return ['/marketplace-static/images/paymentMethods/applepay.svg'];
      case PaymentMethodsType.GooglePay:
        return ['/marketplace-static/images/paymentMethods/googlepay.svg'];
      default:
        return [];
    }
  };

  const orderMap: Record<string, number> = useMemo(
    () => ({
      'Credit Card': 1,
      ApplePay: 2,
      GooglePay: 3,
      PayPal: 4,
      Affirm: 5,
      Sezzle: 6,
    }),
    [],
  );

  const sortedPaymentMethods = useMemo(
    () =>
      [...(paymentMethods || [])].sort((a, b) => (orderMap[a.paymentType] || 999) - (orderMap[b.paymentType] || 999)),
    [paymentMethods, orderMap],
  );

  return (
    <div className={clsx(styles.paymentMethodsDisplay, className)}>
      {sortedPaymentMethods.map((method) =>
        getImageLinks(method.paymentType).map((link, index) => (
          <div key={`${method.paymentType}-${index}`}>
            <Image src={link} alt={`${method.paymentType} method ${index}`} width={35} height={24} />
          </div>
        )),
      )}
    </div>
  );
};

export default PaymentMethodsDisplay;
